import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ToolbarWrapper from 'components/templates/Wrappers/Toolbars/ToolbarWrapper/ToolbarWrapper';

const StyledCollectionsBarWrapper = styled(ToolbarWrapper)`
  ${ComponentStyles}
`;

StyledCollectionsBarWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionsBarWrapper;
